import styles from "./TextAreaField.module.css";

const TextAreaField = ({

    id,

    name,

    label,

    icon,

    value = "",

    placeholder = "",

    rows = 4,

    error,

    touched,

    hint,

    required = false,

    disabled = false,

    onChange,

    onBlur,

}) => {

    const hasError = Boolean(
        error && touched
    );

    return (

        <div
            className={`${styles.wrapper} ${
                hasError
                    ? styles.error
                    : ""
            }`}
        >

            <div className={styles.label}>

                {

                    icon &&

                    <span className={styles.icon}>
                        {icon}
                    </span>

                }

                <span>

                    {label}

                    {

                        required &&

                        <small>*</small>

                    }

                </span>

            </div>

            <textarea

                id={id}

                name={name}

                rows={rows}

                value={value}

                placeholder={placeholder}

                disabled={disabled}

                onChange={onChange}

                onBlur={onBlur}

                className={styles.textarea}

            />

            {

                hint &&

                !hasError &&

                <div className={styles.hint}>

                    {hint}

                </div>

            }

            {

                hasError &&

                <div className={styles.errorText}>

                    {error}

                </div>

            }

        </div>

    );

};

export default TextAreaField;